uniform float time;
uniform float progress;
uniform sampler2D texture1;
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform float uRange1;
uniform float uRange2;
uniform float uScale1;
uniform float uScale2;
uniform float uRotation;
uniform vec4 resolution;
varying vec2 vUv;
varying vec3 vPosition;
float PI = 3.141592653589793238;

// NOISE
float mod289(float x){return x - floor(x * (1.0 / 289.0)) * 289.0;}
vec4 mod289(vec4 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}
vec4 perm(vec4 x){return mod289(((x * 34.0) + 1.0) * x);}

float noise(vec3 p){
    vec3 a = floor(p);
    vec3 d = p - a;
    d = d * d * (3.0 - 2.0 * d);

    vec4 b = a.xxyy + vec4(0.0, 1.0, 0.0, 1.0);
    vec4 k1 = perm(b.xyxy);
    vec4 k2 = perm(k1.xyxy + b.zzww);

    vec4 c = k2 + a.zzzz;
    vec4 k3 = perm(c);
    vec4 k4 = perm(c + 1.0);

    vec4 o1 = fract(k3 * (1.0 / 41.0));
    vec4 o2 = fract(k4 * (1.0 / 41.0));

    vec4 o3 = o2 * d.z + o1 * (1.0 - d.z);
    vec2 o4 = o3.yw * d.x + o3.xz * (1.0 - d.x);

    return o4.y * d.y + o4.x * (1.0 - d.y);
}

float lines(vec2 uv, float offset){
	return smoothstep(
		0., 0.5 + offset*0.5,
		0.5*abs((sin(uv.x*35.) + offset*2.))
	);
}



mat2 rotate2D(float angle){
	return mat2(
		cos(angle),-sin(angle),
		sin(angle),cos(angle)
	);
}


vec2 rotate(vec2 v, float a) {
	float s = sin(a);
	float c = cos(a);
	mat2 m = mat2(c, -s, s, c);
	return m * v;
}
vec2 mirrored(vec2 v) {
	vec2 m = mod(v,2.);
	return mix(m,2.0 - m, step(1.0 ,m));
}
void main()	{

	// vec3 uColor1 =  vec3(0.108, 0.464, 0.760);
	// vec3 uColor2 =  vec3(0.119, 0.277, 0.724);
	// vec3 uColor3 =  vec3(0.077, 0.196, 0.572);
	// vec3 baseThird = vec3(0.,0.,1.);
	float n = noise(vPosition*vec3(1.5*uScale1) +vec3(1.,1.,1.)*time);
	// vec3 color1 = vec3(1.,0.,0.);
	// vec3 color2 = vec3(0.,1.,0.);
	// vec3 color3 = vec3(0.,0.,1.);

	vec2 baseUV = rotate2D(n)*vPosition.xy*0.1*uScale2;
	float basePattern = lines(baseUV, uRange1);
	float secondPattern = lines(baseUV, uRange2);

	vec3 baseColor = mix(uColor2,uColor1,basePattern);
	vec3 secondBaseColor = mix(baseColor,uColor3,secondPattern);


	// vec2 newUV = (vUv - vec2(0.5))*resolution.zw + vec2(0.5);
	
	float noise = vUv.y + .1*noise(vec3(vUv.x*10.,vUv.y*10. + time,time/2.));
	vec2 myuv = fract(vec2(vUv.x,noise));
	myuv = mirrored(rotate(myuv,uRotation + 1.17));
	vec4 tt = texture2D(texture1, myuv);
	gl_FragColor = vec4(vec3(secondBaseColor),1.);
	gl_FragColor = vec4(vec3(vUv*2.,0.),1.);
	gl_FragColor =tt;
	gl_FragColor =vec4(secondBaseColor,1.);
}